import { render, staticRenderFns } from "./Elliptical.vue?vue&type=template&id=f370c9cc&"
import script from "./Elliptical.vue?vue&type=script&lang=js&"
export * from "./Elliptical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports